import React, { useEffect, useState } from 'react';
import { fetchStudentSubcriptions } from '../../actions/subscribers';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import profileimag from "../../assets/profiledefaultimg.webp";
import './MySubscriptions.css';
import { Spinner } from 'react-bootstrap';
import { fetchTests } from '../../actions/testActions';
import { fetchUserDataRequest } from '../../actions/dashboardActions';

const MySubscriptions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Redux state
  const studentSubcriptions = useSelector(state => state.subcriptiondata.studentSubcriptions);
  const testsData = useSelector(state => state.tests.tests);
  const studentProfileData = useSelector(state => state.dashboard.userData);
  const studentSubcriptionsloading = useSelector(state => state.subcriptiondata.studentSubcriptionsloading);

  // Local state
  const [creatorId, setCreatorId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [creatorTests, setCreatorTests] = useState([]);

  useEffect(() => {
    if (!studentSubcriptions.length) {
      dispatch(fetchStudentSubcriptions()); // Fetch subscriptions when the component mounts}
    }
      dispatch(fetchTests(1, 0, null,'',false)); // Fetch tests when the component mounts
    if (!studentProfileData) {
      dispatch(fetchUserDataRequest()); // Fetch subscriptions when the component mounts 
    }
  }, []); 

  // Filter tests by category
  const filteredCategoryTests = React.useMemo(() => {
    return selectedCategory === 'All'
      ? creatorTests
      : creatorTests.filter(test => test.category === selectedCategory);
  }, [creatorTests, selectedCategory]);


  const creatorTestCounts = React.useMemo(() => {
    const counts = {};
    testsData.forEach(test => {
      if (test.teacherId) {
        counts[test.teacherId] = (counts[test.teacherId] || 0) + 1;
      }
    });
    return counts;
  }, [testsData]);


  // Filter tests when creatorId changes
  useEffect(() => {
    if (creatorId && testsData) {
      const filteredTests = testsData.filter(test => test.teacherId === creatorId);
      setCreatorTests(filteredTests);
    }
  }, [testsData, creatorId]);

  // Handlers
  const handleAttemptTest = (test) => {
    navigate(`/exam-terms-conditions`, { state: { test, studentProfileData } });

  };

  const handleBackClick = () => {
    setCreatorId(null);
    setSelectedCategory('All');
    window.scrollTo(0, 0);
  };

  const handleCreatorSelect = (id) => {
    setCreatorId(id);
    window.scrollTo(0, 0);
  };

  // Loading state
  // Handle loading state
  if (studentSubcriptionsloading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }


  // Main render
  return (
    <div className='ms-container' style={{ alignItems: 'center' }}>
      {creatorId ? (
        <div className='ms-fade-in'>
          {/* Creator Content View */}
          <div className='ms-section-header'>
            <button
              className='ms-back-button'
              onClick={handleBackClick}
              aria-label="Back to all subscriptions"
            >
              ← All Subscriptions
            </button>
            <h1 className='ms-section-title'>
              Content by {creatorTests[0]?.teacherName || 'this creator'}
            </h1>
          </div>

          {creatorTests.length === 0 ? (
            <div className='ms-empty-state'>
              <h3>No content available yet</h3>
              <p>This creator hasn't published any tests or content.</p>
            </div>
          ) : (
            <>
              <div className='ms-filter-bar'>
                <div className='ms-filter-group'>
                  <label htmlFor="categoryFilter" className='ms-filter-label'>
                    Filter by:
                  </label>
                  <select
                    id="categoryFilter"
                    className='ms-category-filter'
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                    aria-label="Filter content by category"
                  >
                    <option value="All">All Categories</option>
                    {[...new Set(creatorTests.map(test => test.category))]
                      .filter(Boolean)
                      .sort()
                      .map(category => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                  </select>
                </div>
                <div className='ms-results-count'>
                  Showing {filteredCategoryTests.length} {filteredCategoryTests.length === 1 ? 'item' : 'items'}
                </div>
              </div>

              <div className='ms-grid ms-content-grid'>
                {filteredCategoryTests.map((test) => (
                  <div key={test._id} className='ms-card'>
                    <div className='ms-card-badge'>
                      {test.category || 'Uncategorized'}
                    </div>
                    <div className='ms-card-header'>
                      <h2 style={{ fontSize: '1.25rem', margin: 0 }}>
                        {test.title}
                      </h2>
                    </div>
                    <div className='ms-card-body'>
                      <h4 style={{ marginBottom: '0.75rem' }}>
                        {test.testName || 'No description provided'}
                      </h4>
                      <div className='ms-meta-info'>
                        <span className='ms-meta-item'>
                          📝 {test.questions.length} Questions
                        </span>
                        <span className='ms-meta-item'>
                          ⏱️ {test.totalMinutes} mins
                        </span>
                      </div>
                    </div>
                    <div className='ms-card-footer'>
                      <button
                        className='ms-btn ms-btn-primary ms-btn-block'
                        onClick={() => handleAttemptTest(test)}
                        aria-label={`Attempt ${test.title}`}
                      >
                        Start Test
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      ) : (
        <div className='ms-fade-in'>
          {/* Subscriptions List View */}
          <div className='ms-section-header'>
            <h1 className='ms-section-title'>My Subscriptions</h1>
            <p className='ms-section-subtitle'>
              {studentSubcriptions.length} {studentSubcriptions.length === 1 ? 'creator' : 'creators'} you follow
            </p>
          </div>

          {studentSubcriptions.length === 0 ? (
            <div className='ms-empty-state'>
              <h3>No subscriptions yet</h3>
              <p>You haven't subscribed to any creators yet.</p>
              <button
                className='ms-btn button-design'
                onClick={() => navigate('/allcreators')}
                aria-label="Explore creators"
              >
                Explore Creators
              </button>
            </div>
          ) : (
            <div className='ms-grid ms-creators-grid'>
              {studentSubcriptions.map((creator) => (
                <article
                  key={creator._id}
                  className='ms-card ms-creator-card'
                  onClick={() => handleCreatorSelect(creator._id)}
                  onKeyDown={(e) => e.key === 'Enter' && handleCreatorSelect(creator._id)}
                  tabIndex={0}
                  aria-label={`View content by ${creator.name}`}
                >
                  <div className='ms-creator-avatar-container'>
                    <img
                      src={creator.imagepath || profileimag}
                      alt={`${creator.name}'s profile`}
                      className='ms-creator-avatar'
                      loading="lazy"
                      onError={(e) => e.target.src = profileimag}
                    />
                    <div className='ms-subscriber-count'>
                      👥 {creator.subscribers.length}
                    </div>
                  </div>
                  <div className='ms-card-body'>
                    <h2 style={{ fontSize: '1.25rem', margin: 0 }}>
                      {creator.name}
                    </h2>
                    <div className='ms-meta-info'>
                      <span className='ms-meta-item'>
                        📚 {creatorTestCounts[creator._id] || 0} tests
                      </span>
                    </div>
                    <button
                      className='ms-btn s-btn-primary ms-btn-block'
                      style={{ marginTop: '1rem' }}
                      aria-label={`View ${creator.name}'s content`}
                    >
                      View Content →
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MySubscriptions;